module.exports = __webpack_public_path__ + "static/media/chevron-right.42f7f23b.svg";